import { getLocale } from "../runtime";

const sv_gbcountryenglish = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Great Britain`
};

const gbcountryenglish = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_gbcountryenglish(inputs)
	return "gbCountryEnglish";
};

export { gbcountryenglish as "gbCountryEnglish" };